/**
 * @file textarea.tsx
 * @description Textarea-примитив (phase08.5).
 */

import * as React from "react";

import { cn } from "@/lib/utils";

export const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    data-slot="textarea"
    className={cn(
      "flex min-h-20 w-full rounded-md bg-input px-3 py-2 text-sm text-on-surface",
      "placeholder:text-on-surface-muted resize-y",
      "transition-all outline-none",
      "focus-visible:bg-surface-lowest focus-visible:[box-shadow:inset_0_-2px_0_var(--primary)]",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "aria-invalid:[box-shadow:inset_0_-2px_0_var(--destructive)]",
      className,
    )}
    {...props}
  />
));
Textarea.displayName = "Textarea";
